export const getLocalDate = (dateString: string) => {
  const isSimpleDate = /^\d{4}-\d{2}-\d{2}$/.test(dateString);

  let localDate: Date;

  if (isSimpleDate) {
    localDate = new Date(dateString.replace(/-/g, "/"));
    localDate.setHours(0, 0, 0, 0);
  } else {
    localDate = new Date(dateString);
  }

  return localDate;
};

/**
 * Merge a day picked from the calendar with the time of the currently selected
 * date. The calendar only emits a day, so we keep the existing hours/minutes
 * (defaulting to 23:59 when nothing is selected yet) to avoid resetting the
 * user's chosen time when they change only the day.
 */
export const applyPickedDay = (
  dateString: string,
  currentDate: Date | null
) => {
  const picked = getLocalDate(dateString);
  if (currentDate) {
    picked.setHours(currentDate.getHours(), currentDate.getMinutes(), 0, 0);
  } else {
    picked.setHours(23, 59, 0, 0);
  }
  return picked;
};

/**
 * Apply a "HH:mm" time string (from the time picker) to a base date, keeping
 * the base date's day and zeroing seconds/milliseconds. Mirrors the previous
 * `date-fns` `parse(value, "HH:mm", base)` behaviour: falls back to now when
 * there is no base date, and returns an invalid date for malformed or
 * out-of-range input (rather than rolling "24:00" over to the next day, which
 * `Date#setHours` would do silently).
 */
export const applyPickedTime = (value: string, baseDate: Date | null) => {
  const [hourStr, minuteStr] = value.split(":");
  const hours = Number(hourStr);
  const minutes = Number(minuteStr);
  if (
    !Number.isInteger(hours) ||
    !Number.isInteger(minutes) ||
    hours < 0 ||
    hours > 23 ||
    minutes < 0 ||
    minutes > 59
  ) {
    return new Date(NaN);
  }
  const result = new Date(baseDate ?? new Date());
  result.setHours(hours, minutes, 0, 0);
  return result;
};
